<template>
  <div id="popup-wrap">
    <van-popup v-model="isRealName" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">实名认证</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handelCancel"/>
        </div>
        <div class="padding-20-15 padding-t-0">
          <div class="label-title padding-b-8">身份证号</div>
          <div class="input-box">
            <input type="text" class="padding-10-12" v-model="realNameForm.card_no" placeholder="请输入您的真实身份证号" >
          </div>
        </div>
        <div class="padding-20-15 padding-t-0">
          <div class="label-title padding-b-8">手机号</div>
          <div class="input-box">
            <input type="text" class="padding-10-12" v-model="realNameForm.mobile" placeholder="请输入您的手机号" @input="checkMobile">
          </div>
        </div>
        <div class="padding-20-15 padding-t-0">
          <div class="label-title padding-b-8">验证码</div>
          <div class="code-box">
            <div class="input-box">
              <input type="text" class="padding-10-12" v-model="realNameForm.code" placeholder="请输入验证码">
            </div>
            <div v-show="!showCountDown" class="code-btn" @click="sendSms">
              获取验证码
            </div>
            <div v-show="showCountDown" class="clock-btn">
              重新发送({{countDown}})s
            </div>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="sure-btn" @click="handelSubmit">提交</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {alipayAuth } from '@/api/user'
export default {
  name: "Realname",
  props: {
    /* info: {
      type: Object,
      default: {}
    }, */
  },
  created() {
    //console.log(this.info)
  },
  data: function () {
    return {
      isRealName: false,
      realNameForm: {
        card_no: '',
        mobile: '',
        code: '',
      },
      loading:false,
      ruleValidate: {},
      showCountDown:false,//显示倒计时
      countDown: 60,  //倒计时
    }
  },
  methods: {
    init: function () {
      this.isRealName = true
    },
    handelCancel: function () {
      this.isRealName = false
    },
    handelSubmit: function () {
      if(this.loading){
        return
      }
      if(!this.validateCardNo() || !this.validateMobile() || !this.validateCode()){
        this.$toast.fail(this.tip)
        return
      }
      this.loading = true
      this.loading = false
      this.$Message.success('接口待接入')
      /* alipayAuth(this.realNameForm).then(response => {
        this.loading = false
        this.$Message.success(response.message)
        this.handelCancel();
      }).catch(error => {
        this.loading = false
        console.log(error)
      }) */
    },
    sendSms(){
      if(!this.validateMobile()){
        this.$toast.fail(this.tip)
        return
      }
      this.showCountDown = true
      // RealnameSms({
      //   mobile: this.realNameForm.mobile,
      // }).then(response => {
      //   this.$toast.success(response.message)
      //   this.timer = setInterval(()=>{
      //     this.countDown--
      //     if(this.countDown === 0){
      //       this.showCountDown = false
      //       this.countDown = 60;
      //       clearInterval(this.timer)
      //     }
      //   },1000)
      // }).catch(error => {
      //   console.log(error)
      //   this.showCountDown = false
      // })
    },
    //监听手机
    checkMobile() {
      this.realNameForm.mobile = this.realNameForm.mobile.replace(/[^\d]/g, '')
    },
    //验证身份证号
    validateCardNo() {
      if(!this.realNameForm.card_no.length){
        this.tip = '请输入您的真实身份证号'
        return false;
      }
      if (this.realNameForm.card_no.length < 15 || this.realNameForm.card_no.length > 18) {
        this.tip = '身份证号位数有误'
        return false;
      }
      return true;
    },
    // 验证手机
    validateMobile() {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.realNameForm.mobile))) {
        this.tip = '手机号格式不正确'
        return false;
      }
      return true;
    },
    //验证 验证码
    validateCode() {
      if (!(this.realNameForm.code.length == 6)) {
        this.tip = '验证码长度错误'
        return false;
      }
      return true
    },
  }
}
</script>

<style lang="less" scoped>
.popup-wrap{
  width: 84%;
  background: #FFFFFF;
  border-radius: 8px;
  .popup-box{
    font-family: Alibaba-PuHuiTi-R;
    .popup-header{
      padding: 25px 15px;
      text-align: center;
      font-family: Alibaba-PuHuiTi-M;
      font-size: 18px;
      color: #222222;
      overflow: hidden;
      position: relative;
      img{
        width: 22px;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        -ms-transform: translateY(-50%);	/* IE 9 */
        -moz-transform: translateY(-50%); 	/* Firefox */
        -webkit-transform: translateY(-50%); /* Safari 和 Chrome */
        -o-transform: translateY(-50%); 	/* Opera */
      }
    }
    .label-title{
      font-size: 13px;
      color: #666666;
    }
    .input-box{
      background: #FAFAFA;
      border-radius: 1px;
      input{
        font-size: 14px;
        color: #222222;
        letter-spacing: 0;
        background: #FAFAFA;
      }
      input::-webkit-input-placeholder{
        color: #C1C1C1;
      }
    }
    .code-box{
      display: flex;
      justify-content: space-between;
      .input-box{
        margin-right: 10px;
        input{
          width: 90%;
        }
      }
      .code-btn,.clock-btn{
        height: 40px;
        border-radius: 1px;
        font-size: 15px;
        color: #FFFFFF;
        padding: 10px 0px;
        white-space: nowrap;
        width: 45%;
        text-align: center;
      }
      .code-btn{
        background: #FF8622;
      }
      .clock-btn{
        background: #E1E1E1;
      }
    }
    .btn-wrap{
      background: #FF8622;
      border-radius: 20px;
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
      margin: 10px 20px 20px;
      padding: 9px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/statistics/modal/Realname.vue